import { createBrowserHistory } from 'history';
import { ROUTES } from '../constant';

const baseHistory = createBrowserHistory();

export const history = {
  ...baseHistory, // spread all properties of the original history object
  push: (path: string, state?: any) => {
    if (path !== baseHistory.location.pathname || path === ROUTES.BASE.EVENTS) {
      baseHistory.push(path, state);
    }
  },
};
